/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsDefendifySettingRequest
 */
export interface JumboStructsDefendifySettingRequest {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifySettingRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifySettingRequest
     */
    setting?: string;
}

/**
 * Check if a given object implements the JumboStructsDefendifySettingRequest interface.
 */
export function instanceOfJumboStructsDefendifySettingRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsDefendifySettingRequestFromJSON(json: any): JumboStructsDefendifySettingRequest {
    return JumboStructsDefendifySettingRequestFromJSONTyped(json, false);
}

export function JumboStructsDefendifySettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsDefendifySettingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'setting': !exists(json, 'setting') ? undefined : json['setting'],
    };
}

export function JumboStructsDefendifySettingRequestToJSON(value?: JumboStructsDefendifySettingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'setting': value.setting,
    };
}

